<template>
  <div id="hero" class="hero-wrap style2">
    <Carousel
      :autoplay="5000"
      :items-to-show="1"
      :wrap-around="true"
      pause-autoplay-on-hover
      class="hero-slider-one"
    >
      <Slide v-for="(index, slide) in slider" :key="slide">
        <div
          class="hero-slide-item bg-f"
          :style="{
            'background-image': `url(${index.image})`,
          }"
        >
          <div class="container">
            <div class="row gx-5 align-items-center">
              <div class="col-lg-6 col-md-9">
                <div class="hero-content">
                  <span>{{ index.subTitle }}</span>
                  <h1>{{ index.heading }}</h1>
                  <p>{{ index.shortDesc }}</p>
                  <div class="hero-btn">
                    <a href="#appointment" class="btn style2">
                      Book An Appointment
                    </a>
                    <div
                      class="watch-video"
                      v-on:click="isPopupMethod(isPopup)"
                      style="cursor: pointer"
                    >
                      <span class="play-btn">
                        <i class="flaticon-play-1"></i>
                      </span>
                      <span class="play-text">Watch Our Videos </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Slide>

      <template #addons>
        <Navigation />
      </template>
    </Carousel>
  </div>

  <div class="popup-video" v-if="isPopup">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="popup-overlay-close" v-on:click="isPopupMethod(isPopup)">
            <div class="popup-overlay-close-line"></div>
            <div class="popup-overlay-close-line"></div>
          </div>

          <div class="play-video">
            <iframe
              class="responsive-iframe"
              src="https://www.youtube.com/embed/DublqkOSBBA"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  name: "MainBanner",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    isPopup: false,
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    slider: [
      {
        id: 1,
        image: require("../../assets/images/hero/hero-slider-4.jpg"),
        subTitle: "Welcome To Clean Teeth",
        heading: "Get Ready For Your Best Experience With Us",
        shortDesc:
          "Lorem ipsum dolor sit amet consectetuer adipiscing Phasellus hendrerit lorem dolor sit nibh nec urna. In nisi neque, aliquet vel dapibus id dolor sit amet standard dummy text ever since the when an unknown printer.",
      },
      {
        id: 2,
        image: require("../../assets/images/hero/hero-slider-5.jpg"),
        subTitle: "Welcome To Clean Teeth",
        heading: "Our Doctors Are Always In Your Side",
        shortDesc:
          "Lorem ipsum dolor sit amet consectetuer adipiscing Phasellus hendrerit lorem dolor sit nibh nec urna. In nisi neque, aliquet vel dapibus id dolor sit amet standard dummy text ever since the when an unknown printer.",
      },
      {
        id: 3,
        image: require("../../assets/images/hero/hero-slider-6.jpg"),
        subTitle: "Welcome To Clean Teeth",
        heading: "Doctors Give Us A Better & Healthy Life",
        shortDesc:
          "Lorem ipsum dolor sit amet consectetuer adipiscing Phasellus hendrerit lorem dolor sit nibh nec urna. In nisi neque, aliquet vel dapibus id dolor sit amet standard dummy text ever since the when an unknown printer.",
      },
    ],
  }),
  methods: {
    isPopupMethod(isPopup: unknown) {
      return (this.isPopup = !isPopup);
    },
  },
});
</script>